<template lang="pug">
  //- TODO: v-ifにしたほうがよさそう
  .goqme-textchat(:class="isShow")
    button.goqme-textchat__close-btn(
      type="button",
      @click="closeTextChat"
    )
      i.far.fa-times.text-white
    .goqme-textchat__wrapper
      .goqme-textchat__body
        #js-chatTimeline.mb-0.list-unstyled.goqme-textchat__timeline
          li.goqme-textchat__timeline-item(
            v-for="message in messages",
            :class="{'is-other' : (message.peerId !== myPeerId)}"
          )
            .goqme-textchat__timeline-chatdata
              .goqme-textchat__timeline-message-wrapper
                .goqme-textchat__timeline-meta
                  .goqme-textchat__timeline-date {{ message.time }}
                  .goqme-textchat__timeline-user-name {{ message.userName }}
                .goqme-textchat__timeline-message(v-html="message.msg")
          li.goqme-textchat__copyright
            | Powered&nbsp;by&nbsp;
            a.goqme-textchat__copyright-link(
              href="https://goq.me",
              target="_blank"
            )
              | GoQme
      .goqme-textchat__footer
        textarea.form-control.goqme-textchat__textarea(
          :placeholder="placeholder",
          v-model="chatMessage",
          @keydown.enter="keyCheck",
          :disabled="stealth"
        )
        .position-relative.d-flex.justify-content-end.align-items-center.goqme-textchat__send-controller
          .form-check.mr-3
            input#sendKey.form-check-input(
              type="checkbox",
              checked,
              @change="updateSendKey",
              :disabled="stealth"
            )
            label.form-check-label.fsz-14(for="sendKey")
              | Enterで送信
          button.goqme-textchat__send-btn(
            type="button",
            @click="sendChat"
            :disabled="stealth"
          )
            | 送信
</template>

<script>
export default {
  name: 'TextChat',
  data () {
    return {
      checked: true,
      toggleText: {
        true: 'メッセージを入力してください。Enterキーで送信できます。',
        false: 'メッセージを入力してください。Shift+Enterキーで送信できます。'
      },
      chatMessage: ''
    }
  },
  computed: {
    // TODO: Appからpropsで出したほうがいいかも？
    isShow () {
      this.updatePosition()
      return (this.$store.state.showTextChat) ? 'is-show' : ''
    },
    messages () {
      return this.$store.state.textChat
    },
    placeholder () {
      return this.toggleText[String(this.checked)]
    },
    myPeerId () {
      return this.$store.state.peerId
    },
    localUser () {
      return this.$store.getters.localUser
    },
    stealth () {
      return this.$store.state.stealth
    }
  },
  watch: {
    messages () {
      this.updatePosition()
    }
  },
  methods: {
    closeTextChat () {
      const flag = !this.$store.state.showTextChat
      this.$store.dispatch('updateShowTextChat', { flag })
    },
    updatePosition () {
      // TODO: setTimeout以外でちゃんとやりたい
      setTimeout(() => {
        const $timeLine = document.getElementById('js-chatTimeline')

        const posY = $timeLine.scrollHeight
        const $body = document.querySelector('.goqme-textchat__body')
        $body.scrollTo(0, posY)
      }, 10)
    },
    updateSendKey (e) {
      this.checked = e.target.checked
    },
    keyCheck (e) {
      if (event.keyCode !== 13) return

      // Enter押下時にEnterのみかShift+Enterか判別してチャットを送信できるか
      let sendFlag = false

      switch (e.shiftKey) {
        case true:
          sendFlag = !this.checked
          break
        case false:
          sendFlag = this.checked
          break
        default:
          break
      }

      if (sendFlag === true) {
        e.preventDefault()
        this.sendChat()
      }
    },
    escape (msg) {
      const str = msg.replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')

      return str.replace(/\r\n/g, '<br />').replace(/(\n|\r)/g, '<br />')
    },
    sendChat () {
      let msg = this.chatMessage

      // 1文字以上かつ空白文字でなければ送信
      if (msg.length === 0) return

      // textareaの文字をescapeする
      // eslint-disable-next-line no-irregular-whitespace
      const pattern = /^[\s|　]+$/

      if (msg.match(pattern) === null) {
        // 文字をエスケープ
        msg = this.escape(msg)

        // 時間を形成
        const date = new Date()
        const hour = date.getHours()
        const minutes = date.getMinutes()
        const time = `${String(hour).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`

        const payload = {
          peerId: this.$store.state.peerId,
          type: 'textChat',
          userName: this.localUser.name,
          msg,
          time
        }

        this.$store.state.room.send(payload)
        this.$store.dispatch('updateTextChat', { payload })
        this.chatMessage = ''
        this.updatePosition()
      }
    }
  }
}
</script>
